import { rootApi } from '../user/api';

// Define a service using a base URL and expected endpoints
const apiWithTag = rootApi.enhanceEndpoints({
  addTagTypes: ['CreateLot'],
});

export const createLotApi = apiWithTag.injectEndpoints({
  endpoints: (builder) => ({
    findCreateLotSummaryAllUnit: builder.query({
      query: (id) => `create_lot/summary_all_unit`,
      providesTags: (result, error, arg) => {
        return result ? [{ type: 'CreateLot', id: result.id }] : ['CreateLot'];
      },
    }),

    findCreateLot: builder.mutation({
      query: (body) => ({
        url: `create_lot/create_lot`,
        method: 'POST',
        body: body,
      }),

      keepUnusedDataFor: 0,
      providesTags: ['CreateLot'],
    }),

    findCheckManualLot: builder.mutation({
      query: (body) => ({
        url: `create_lot/check_manual_lot`,
        method: 'POST',
        body: body,
      }),

      keepUnusedDataFor: 0,
    }),
    findSaveManualLot: builder.mutation({
      query: (body) => ({
        url: `create_lot/check_manual_lot`,
        method: 'POST',
        body: body,
      }),

      keepUnusedDataFor: 0,
    }),

    // findCreateLotByFrom: builder.query({
    //   query: (id) => ({
    //     url: `create_lot/search_from?=${id}`,
    //     // ç
    //   }),
    //   keepUnusedDataFor: 0,
    //   providesTags: ['CreateLot'],
    // }),

    findCreateLotSearchByFrom: builder.query({
      query: (payload) => ({
        url: `create_lot/search_from?plan_id=${payload.plan_id}&from_id=${payload.from_id}`,
        method: 'GET',
      }),
      keepUnusedDataFor: 0,
      providesTags: ['CreateLot'],
    }),

    download: builder.query({
      query: (payload) => ({
        url: `create_lot/download?plan_id=${payload.plan_id}`,
        method: 'GET',
        responseHandler: (response) => response.text(),
      }),
      keepUnusedDataFor: 0,
      providesTags: ['CreateLot'],
    }),

    findCreateLotClusterByRegion: builder.mutation({
      query: (payload) =>
        `create_lot/region?plan_id=${payload.plan_id}&region_id=${payload.region_id}&from_id=${payload.from_id}`,
      keepUnusedDataFor: 0,
      providesTags: ['CreateLot'],
    }),
    // findCreateLotBySubCluster: builder.mutation({
    //   query: (id) => `create_lot/sub_cluster?=${id}`,
    //   keepUnusedDataFor: 0,
    //   providesTags: ['CreateLot'],
    // }),
    findCreateLotBySubCluster: builder.mutation({
      query: (payload) =>
        `create_lot/sub_cluster?plan_id=${payload.plan_id}&from_id=${payload.from_id}&cluster_id=${payload.cluster_id}`,
      keepUnusedDataFor: 0,
      providesTags: ['CreateLot'],
    }),
    setDiagramPeriodCreateLot: builder.mutation({
      query: (payload) => ({
        url: `diagram_period/`,
        method: 'POST',
        body: payload,
      }),

      keepUnusedDataFor: 0,
      providesTags: ['CreateLot'],
    }),
    searchDataYardCreateLot: builder.mutation({
      query: (payload) =>
        `create_lot/display_summary_volume/?period_from=${payload.period_from}&period_to=${payload.period_to}&location_from=${payload.location_from}`,
      keepUnusedDataFor: 0,
      providesTags: ['CreateLot'],
    }),
    uploadFileCreateLot: builder.mutation({
      query: (payload) => ({
        url: `create_lot/create_or_update_file/`,
        method: 'POST',
        body: payload,
      }),

      keepUnusedDataFor: 0,
      providesTags: ['CreateLot'],
    }),
    findFilterDataCreateLot: builder.mutation({
      query: (payload) =>
        `create_lot/filter_data/?period_from=${payload.period_from}&period_to=${payload.period_to}&location_from=${payload.location_from}`,
      keepUnusedDataFor: 0,
      providesTags: ['CreateLot'],
    }),
    findFilterSearchCreateLot: builder.mutation({
      query: (payload) =>
        `create_lot/display_detail_volume/?volume_date=${payload.volume_date}&vehicle_type=${payload.vehicle_type}&location_from=${payload.location_from}&location_to=${payload.location_to}&region=${payload.region}&limit=${payload.limit}&offset=${payload.offset}`,
      keepUnusedDataFor: 0,
      providesTags: ['CreateLot'],
    }),
    editVolumeCreateLot: builder.mutation({
      query: (payload) => ({
        url: `create_lot/edit_volume/`,
        method: 'PATCH',
        body: payload,
      }),

      keepUnusedDataFor: 0,
      providesTags: ['CreateLot'],
    }),
    clearDataVolumeCreateLot: builder.mutation({
      query: (payload) => ({
        url: `create_lot/clear_data/`,
        method: 'DELETE',
        body: payload,
      }),

      keepUnusedDataFor: 0,
      providesTags: ['CreateLot'],
    }),
    confirmDataVolumeCreateLot: builder.mutation({
      query: (payload) => ({
        url: `create_lot/confirm_data/`,
        method: 'POST',
        body: payload,
      }),

      keepUnusedDataFor: 0,
      providesTags: ['CreateLot'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useFindCreateLotMutation,
  useFindCreateLotSearchByFromQuery,
  useLazyDownload,
  useFindCreateLotClusterByRegionMutation,
  useFindCreateLotBySubClusterMutation,
  // useFindEntryCreateLotMutation,
  useFindCreateLotSummaryAllUnitQuery,
  useSetDiagramPeriodCreateLotMutation,
  useSearchDataYardCreateLotMutation,
  useUploadFileCreateLotMutation,
  useFindFilterDataCreateLotMutation,
  useFindFilterSearchCreateLotMutation,
  useEditVolumeCreateLotMutation,
  useClearDataVolumeCreateLotMutation,
  useConfirmDataVolumeCreateLotMutation,
} = createLotApi;
